var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkasMainHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.496,
    height: 32.716,
    viewBox: "0 0 38.496 32.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(-130.548 -490.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7130",
    "data-name": "Path 7130",
    d: "M152.835,503.771a1.158,1.158,0,1,0,.817.339A1.156,1.156,0,0,0,152.835,503.771Z",
    transform: "translate(9.411 5.992)",
    fill: "#707070",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7133",
    "data-name": "Path 7133",
    d: "M148.09,503.771a1.158,1.158,0,1,0,.817.339A1.156,1.156,0,0,0,148.09,503.771Z",
    transform: "translate(7.22 5.992)",
    fill: "#707070",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7134",
    "data-name": "Path 7134",
    d: "M143.345,503.771a1.158,1.158,0,1,0,.817.339A1.156,1.156,0,0,0,143.345,503.771Z",
    transform: "translate(5.029 5.992)",
    fill: "#707070",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7135",
    "data-name": "Path 7135",
    d: "M137.877,503.772v2.472",
    transform: "translate(3.038 5.993)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7136",
    "data-name": "Path 7136",
    d: "M134.713,503.772v2.472",
    transform: "translate(1.577 5.993)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7138",
    "data-name": "Path 7138",
    d: "M131.843,502.121l5.942-11.326h23.523l5.942,11.326",
    transform: "translate(0.251 0)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1826",
    "data-name": "Ellipse 1826",
    cx: 3.654,
    cy: 3.654,
    r: 3.654,
    transform: "translate(146.144 515.452)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9933",
    "data-name": "Group 9933",
    transform: "translate(131.299 502.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7325",
    "data-name": "Path 7325",
    d: "M155.3,515.529h11.934a1.1,1.1,0,0,0,1.058-1.133V499.674a1.1,1.1,0,0,0-1.058-1.131h-34.88a1.1,1.1,0,0,0-1.055,1.131V514.4",
    transform: "translate(-131.299 -498.543)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7326",
    "data-name": "Path 7326",
    d: "M144.291,515.529H132.355A1.1,1.1,0,0,1,131.3,514.4V499.674a1.1,1.1,0,0,1,1.055-1.131h34.88a1.1,1.1,0,0,1,1.058,1.131V514.4",
    transform: "translate(-131.299 -498.543)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkasMainHover);
export default __webpack_public_path__ + "static/media/okas_main_hover.9a43019500abbf22b63ea80b9c2d4eff.svg";
export { ForwardRef as ReactComponent };